



































































import { Component, Vue } from "vue-property-decorator";
@Component({
    name: "ButtonEight"
})
export default class ButtonEight extends Vue { }
